import React, { ReactElement, useMemo } from 'react';
import { CarouselProps } from 'react-responsive-carousel';
import { Carousel } from 'components/Carousel';
import { useRaffleTabs } from 'contexts/RaffleTabsProvider/RaffleTabsProvider';
import { useNavigation } from 'hooks/useNavigation';

import getMainCarouselConfigs from './MainCarousel.config';
import styles from './MainCarousel.module.scss';

function MainCarousel(): ReactElement {
  const { banners } = getMainCarouselConfigs();
  const { error } = useRaffleTabs();
  const { navigate } = useNavigation();

  const raffleImages = useMemo(() => {
    return banners.map((banner) => (
      <div
        key={banner.imageUrl}
        data-testid="raffleImage"
        {...(banner.toPath && {
          onClick: () => navigate(banner.toPath as string),
        })}>
        <img src={banner.imageUrl} alt={banner.altText} />
      </div>
    ));
  }, []);

  const carouselProps: Partial<Omit<CarouselProps, 'children'>> = {
    autoPlay: true,
    emulateTouch: true,
    showArrows: false,
    showStatus: Array.isArray(raffleImages) && raffleImages.length > 1,
    transitionTime: 100,
    showThumbs: false,
    useKeyboardArrows: false,
    showIndicators: false,
    className: styles.carouselWrapper,
    thumbWidth: 20,
    statusFormatter: (currentIndex, total) => `${currentIndex} / ${total}`,
  };

  if (error) {
    return <></>;
  }

  return <Carousel {...carouselProps}>{raffleImages}</Carousel>;
}

export default MainCarousel;
